import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"

import { withRouter } from "react-router-dom"
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import Rightbar from "../CommonForBoth/RightSidebar"
//Import firebase
import firebase from "firebase/app"
import 'firebase/auth'
//import { requestForToken  } from '../../FirebaseConstants';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import DPAlert from "../../framework/widgets/DPAlert"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Context } from "app-contexts/CommonContexts"

const Layout = props => {
  const dispatch = useDispatch()

  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
  } = useSelector(state => ({
    isPreloader: state.Layout.isPreloader,
    leftSideBarThemeImage: state.Layout.leftSideBarThemeImage,
    leftSideBarType: state.Layout.leftSideBarType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    showRightSidebar: state.Layout.showRightSidebar,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
  }))

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile))
    }
  }

  /*
  layout  settings
  */

  useEffect(() => {
    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }
  }, [isPreloader])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme))
    }
  }, [leftSideBarTheme, dispatch])

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage))
    }
  }, [leftSideBarThemeImage, dispatch])

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth))
    }
  }, [layoutWidth, dispatch])

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType))
    }
  }, [leftSideBarType, dispatch])

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme))
    }
  }, [topbarTheme, dispatch])

  //import from contexts
  const {
    isHeadOffice, approvalNotifications, setUseEffecttrigger, setMenus, getCommonNotifications, menus
  } = useContext(Context);
  //import from contexts



  const [menuItemsFiltered, setmenuItemsFilterd] = useState([])
  const [clientLicense, SetClientLicense] = useState({})

  useEffect(async () => {
    FirebasePermission();
  }, [])
  //Alert Parameter
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  //fcm 
  const [token, setToken] = useState('')

  //** Request permission to enable Notifications for cloud messages */
  const requestPermission = () => {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted.');
      }
    });
  }

  const GetTokenAvaiability = async (strToken, strUser) => {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);
    
    try {
        const response = await fetch(`${ApiURL}remote/token/${strToken}/${strUser}`, {
            method: "GET",
            headers: myHeaders,
            redirect: "follow",
        });

        if (response.status === 200) {
            const result = await response.json();
            return result.data; // Directly return the data from the result
        } else {
            console.log(`Error: ${response.status} ${response.statusText}`);
            return 0; // Return an empty array or handle accordingly
        }
    } catch (error) {
        console.log("Fetch Error: ", error);
        return -1; // Return an empty array or handle the error accordingly
    }
};


  //Check Firebase Permission
  const FirebasePermission = () => {
    requestPermission()
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let user = obj[2]
    const messaging = getMessaging();

    return getToken(messaging, { vapidKey: "BMIrZ36OASGwfafvFKb-IRrQsPFYjne9Qo7UDxxD6-RsYXm2vj_qqDwHi6FRO8LxEx8Z30YIJDBnte2qUnW8naw" })
      .then(async (currentToken) => {
        if (currentToken) {
          let avaiability = await GetTokenAvaiability(currentToken, user);
          if (avaiability == 1) {
            //console.log('No change in token')
          } else {
            // setToken(currentToken)
            // setAlertDescription("Are you sure want to add this device to your notification device list ? ")
            // setsweetAlertShow(true)
            SaveToken(currentToken)
          }
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  }

  const SaveToken = (token) => {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    let userName = obj[2]
    let user = obj[0]
    const authToken = localStorage.getItem("authToken")
    const ApiURL = window.Links.ApiURL
    fetch(`${ApiURL}common/fcm/token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${authToken}`
      },
      body: JSON.stringify({
        strToken: token,
        strUser: userName,
        strDeviceName: user,
        strDeviceType: "WEBAPP"
      })
    }).then(async (Response) => {
      if (Response.status == "200") {
        console.log('Token saved')
      } else if (Response.status == "401") {
        console.log('Token save failed')
      }
    })
  }


  const filterMenu = (searchText) => {
    if (searchText.length > 0) {

      let AlltoOne = []
      let FilterMenu = []

      menus.map(item => {
        item.lstChildren.map(x => {
          let child =
          {
            "strMenuTag": x.strMenuTag,
            "strMenuName": x.strMenuName,
            "strParentMenu": "F00000",
            "strUrl": x.strUrl,
            "strSort": x.strSort,
            "menuDisplay": x.menuDisplay
          }
          AlltoOne.push(child)
        })
      })
      
      let filteredMenu = AlltoOne.filter(item => {
        return item.strMenuName.toLowerCase().includes(searchText.toLowerCase())
      })

      //find dublicates in filteredMenu, and remove them
      let unique = [...new Map(filteredMenu.map(item =>
        [item['strUrl'], item])).values()];
      filteredMenu = unique
   
      FilterMenu = [
        {
          "strMenuTag": "F00000",
          "strMenuName": "Filtered Menu",
          "strSort": "1",
          "strIcon": "bx-search-alt",
          "lstChildren": filteredMenu
        }]

      setmenuItemsFilterd(FilterMenu)

    } else {

      setmenuItemsFilterd([])

    }
  }

  return (
    <React.Fragment>
      <DPAlert
        confirm_both={sweetAlertShow}
        title={"New Device Found !"}
        description={AlertDescription}
        showCancel={true}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
          SaveToken(token)
        }}
        onCancel={() => {
          setsweetAlertShow(false)
        }}
      />

      <div id="preloader">
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header
          toggleMenuCallback={toggleMenuCallback}
          searchOnchange={filterMenu}
          clientLicense={clientLicense}
        />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
          menuItems={menuItemsFiltered.length == 0 ? menus : menuItemsFiltered}

        />
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
      {showRightSidebar ? <Rightbar /> : null}
    </React.Fragment>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default withRouter(Layout)
